import React from 'react'
import Lottie from 'react-lottie'
import * as styles from './index.style'

import * as questions from '../../../assets/json/questions_f4f4f4.json'

const EmptyDataControl_v2 = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: questions.default,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    }
    return (
        <styles.Bound>
            <div className='animation-container'>
                <Lottie options={defaultOptions} height={500} width={500} />  
            </div>
        </styles.Bound>
    )
}

export default React.memo(EmptyDataControl_v2)
